import fs from 'node:fs/promises';
import { parseLooseAppManifest } from '@wix/cli-app-manifest';
import { readBuildManifest } from '../files/build.config.js';

export async function readAppManifest({
  projectFolder,
  serverUrl,
}: {
  projectFolder: string;
  serverUrl?: string;
}) {
  const { appManifestPath, staticsUrlPlaceholder, serverUrlPlaceholder } =
    await readBuildManifest(projectFolder);

  const placeholders = new Map<string, string>();

  if (serverUrl) {
    if (staticsUrlPlaceholder) {
      placeholders.set(staticsUrlPlaceholder, serverUrl);
    }

    if (serverUrlPlaceholder) {
      placeholders.set(serverUrlPlaceholder, serverUrl);
    }
  }

  const manifest = await fs.readFile(appManifestPath, 'utf-8');
  return parseLooseAppManifest(manifest, placeholders);
}
